<section class="campanhas-page resgate">
  @if (plano(); as planoAtual) {
    <app-plano-cabecalho [plano]="planoAtual" rotuloVoltar="Voltar" (voltar)="voltar()" />
  }

  <div class="resgate__painel">
    <app-instituto-filtro
      [institutos]="institutos()"
      [carregando]="carregandoInstitutos()"
      [selecionado]="institutoAtual()?.tipo ?? null"
      (institutoSelecionado)="selecionarInstituto($event)"
      (limpo)="limparInstituto()"
    />

    @if (!institutoAtual()) {
      <app-empty-state message="Escolha um instituto para ver e editar a parametrização." />
    } @else if (carregandoConfiguracao()) {
      <app-empty-state message="Carregando a configuração do instituto…" />
    } @else {
    <div class="resgate__instituto">
      <div class="resgate__instituto-cabecalho">
        <h2 class="resgate__instituto-titulo" data-testid="resgate-instituto-atual">
          Configuração de {{ institutoAtual()!.nome }}
        </h2>
        @if (status(); as statusAtual) {
          <vivest-tag type="status" [variant]="varianteStatus()" data-testid="resgate-status">
            {{ statusAtual }}
          </vivest-tag>
        }
        @if (ultimaAtualizacao(); as data) {
          <span class="resgate__atualizacao" data-testid="resgate-ultima-atualizacao">
            Última atualização: {{ data }}
          </span>
        }
      </div>
      @if (semConfiguracaoSalva()) {
        <p class="resgate__instituto-aviso" role="status" data-testid="resgate-sem-configuracao">
          Este instituto ainda não tem configuração. Os valores abaixo são o padrão;
          ajuste e salve para criar a configuração.
        </p>
      }
    </div>

    <form
      class="resgate-form"
      [formGroup]="form"
      novalidate
      data-testid="resgate-form"
      (ngSubmit)="salvar()"
    >
      <!-- Status e vigência -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-status">
        <div class="resgate-bloco">
          <h2 id="resgate-bloco-status" class="resgate-bloco__titulo">Status e vigência</h2>

        <div class="resgate-vigencia">
          <vivest-select
            class="resgate-campo"
            label="Status"
            name="status"
            status="default"
            error-message=""
            [options]="statusOpcoes"
            formControlName="status"
            data-testid="resgate-status-config"
          ></vivest-select>

          <ng-container formGroupName="vigencia">
            <div class="resgate-campo">
              <label class="campanha-form-label" for="resgate-vigencia-inicio">
                Início da vigência<span class="campanha-form-required" aria-hidden="true">*</span>
              </label>
              <input
                id="resgate-vigencia-inicio"
                type="date"
                class="form-control campanha-form-control"
                formControlName="inicio"
                required
                [class.is-invalid]="
                  vigencia.controls.inicio.touched && vigencia.controls.inicio.invalid
                "
                data-testid="resgate-vigencia-inicio"
              />
            </div>
            <div class="resgate-campo">
              <label class="campanha-form-label" for="resgate-vigencia-fim">Fim da vigência</label>
              <input
                id="resgate-vigencia-fim"
                type="date"
                class="form-control campanha-form-control"
                formControlName="fim"
                aria-describedby="resgate-vigencia-dica"
                [class.is-invalid]="vigencia.hasError('vigenciaIncoerente')"
                data-testid="resgate-vigencia-fim"
              />
            </div>
          </ng-container>
        </div>

        @if (vigencia.controls.inicio.touched && vigencia.controls.inicio.hasError('required')) {
          <p class="resgate-erro" role="alert" data-testid="resgate-erro-vigencia-inicio">
            Informe o início da vigência.
          </p>
        } @else if (vigencia.hasError('vigenciaIncoerente')) {
          <p class="resgate-erro" role="alert" data-testid="resgate-erro-vigencia">
            O fim da vigência não pode ser anterior ao início.
          </p>
        } @else {
          <p id="resgate-vigencia-dica" class="resgate-dica">
            Deixe o fim em branco para uma vigência sem data de término.
          </p>
        }
        </div>
      </vivest-card>

      <!-- Descrição do resgate -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-descricao">
        <div class="resgate-bloco">
          <h2 id="resgate-bloco-descricao" class="resgate-bloco__titulo">Descrição do resgate</h2>

          <div class="resgate-campo">
            <label class="campanha-form-label" for="resgate-descricao">Descrição</label>
            <textarea
              id="resgate-descricao"
              class="form-control campanha-form-control campanha-form-textarea"
              rows="4"
              placeholder="Descreva o resgate"
              [attr.maxlength]="descricaoMaximo"
              formControlName="descricao"
              [class.is-invalid]="descricao.touched && descricao.invalid"
              aria-describedby="resgate-descricao-contador"
              data-testid="resgate-descricao"
            ></textarea>
            <p id="resgate-descricao-contador" class="resgate-dica resgate-descricao__contador" data-testid="resgate-descricao-contador">
              {{ descricao.value.length }}/{{ descricaoMaximo }} caracteres
            </p>
          </div>
        </div>
      </vivest-card>

      <!-- Percentual resgatável: só a regra (total ou parcial) -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-percentual">
        <div class="resgate-bloco" formGroupName="percentual">
          <h2 id="resgate-bloco-percentual" class="resgate-bloco__titulo">Percentual resgatável</h2>

          <div class="resgate-percentual__regra" role="radiogroup" aria-labelledby="resgate-regra-label">
            <span id="resgate-regra-label" class="campanha-form-label">Regra aplicada</span>
            @for (opcao of regraPercentualOpcoes; track opcao.value) {
              <vivest-radio
                label-variant="multi-line"
                name="regra-percentual"
                [value]="opcao.value"
                formControlName="regra"
                [attr.data-testid]="'resgate-regra-' + opcao.value"
              >
                {{ opcao.label }}
              </vivest-radio>
            }
          </div>
        </div>
      </vivest-card>

      <!-- Regime de tributação: pelo menos um, podendo ser os dois -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-tributacao">
        <div class="resgate-bloco" formGroupName="tributacao">
          <h2 id="resgate-bloco-tributacao" class="resgate-bloco__titulo">Regime de tributação</h2>
          <p class="resgate-bloco__descricao">Selecione pelo menos um regime. É possível marcar os dois.</p>

          <div class="resgate-radios">
            <vivest-checkbox
              label-variant="multi-line"
              name="regime-tributacao"
              value="irRegressivo"
              formControlName="irRegressivo"
              data-testid="resgate-tributacao-regressivo"
            >
              IR Regressivo
            </vivest-checkbox>
            <vivest-checkbox
              label-variant="multi-line"
              name="regime-tributacao"
              value="irProgressivo"
              formControlName="irProgressivo"
              data-testid="resgate-tributacao-progressivo"
            >
              IR Progressivo
            </vivest-checkbox>
          </div>

          @if (tributacaoComErro) {
            <p class="resgate-erro" role="alert" data-testid="resgate-erro-tributacao">
              Selecione pelo menos um regime de tributação.
            </p>
          }
        </div>
      </vivest-card>

      <!-- Forma de pagamento -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-pagamento">
        <div class="resgate-bloco" formGroupName="pagamento">
          <h2 id="resgate-bloco-pagamento" class="resgate-bloco__titulo">Forma de pagamento</h2>

        <!-- Excludentes: o resgate é pago de uma vez ou em parcelas. -->
        <div class="resgate-radios" role="radiogroup" aria-label="Forma de pagamento">
          @for (opcao of formaPagamentoOpcoes; track opcao.value) {
            <vivest-radio
              label-variant="multi-line"
              name="forma-pagamento"
              [value]="opcao.value"
              formControlName="forma"
              [attr.data-testid]="'resgate-forma-' + opcao.value"
            >
              {{ opcao.label }}
            </vivest-radio>
          }
        </div>

        <!-- Parâmetros do parcelamento: abrem só quando a forma é "Parcelamento". -->
        <div
          class="resgate-parcelas"
          [class.resgate-parcelas--aberto]="parcelado"
          [attr.aria-hidden]="!parcelado"
          [attr.inert]="parcelado ? null : ''"
          data-testid="resgate-parcelas"
        >
          <div class="resgate-parcelas__conteudo">
            <div class="resgate-parcelas__campos">
              <div class="resgate-campo">
                <label class="campanha-form-label" for="resgate-parcelas-min">
                  Mínimo de parcelas
                </label>
                <input
                  id="resgate-parcelas-min"
                  type="number"
                  inputmode="numeric"
                  class="form-control campanha-form-control resgate-campo__numero"
                  [min]="parcelasMinimo"
                  formControlName="parcelasMinimas"
                  [class.is-invalid]="
                    pagamento.controls.parcelasMinimas.touched &&
                    pagamento.controls.parcelasMinimas.invalid
                  "
                  data-testid="resgate-parcelas-min"
                />
              </div>
              <div class="resgate-campo">
                <label class="campanha-form-label" for="resgate-parcelas-max">
                  Máximo de parcelas
                </label>
                <input
                  id="resgate-parcelas-max"
                  type="number"
                  inputmode="numeric"
                  class="form-control campanha-form-control resgate-campo__numero"
                  [min]="parcelasMinimo"
                  formControlName="parcelasMaximas"
                  [class.is-invalid]="
                    (pagamento.controls.parcelasMaximas.touched &&
                      pagamento.controls.parcelasMaximas.invalid) ||
                    pagamento.hasError('parcelasIncoerentes')
                  "
                  data-testid="resgate-parcelas-max"
                />
              </div>
            </div>

            @if (
              (pagamento.controls.parcelasMinimas.touched &&
                pagamento.controls.parcelasMinimas.invalid) ||
              (pagamento.controls.parcelasMaximas.touched &&
                pagamento.controls.parcelasMaximas.invalid)
            ) {
              <p class="resgate-erro" role="alert">
                Informe uma quantidade de parcelas a partir de {{ parcelasMinimo }}.
              </p>
            } @else if (pagamento.hasError('parcelasIncoerentes')) {
              <p class="resgate-erro" role="alert" data-testid="resgate-erro-parcelas">
                O mínimo de parcelas não pode ser maior que o máximo.
              </p>
            }

            <div class="resgate-campo" role="radiogroup" aria-labelledby="resgate-intervalo-label">
              <span id="resgate-intervalo-label" class="campanha-form-label">
                Intervalo permitido
              </span>
              <div class="resgate-radios">
                @for (opcao of intervaloOpcoes; track opcao.value) {
                  <vivest-radio
                    label-variant="multi-line"
                    name="intervalo-parcelamento"
                    [value]="opcao.value"
                    formControlName="intervalo"
                    [attr.data-testid]="'resgate-intervalo-' + opcao.value"
                  >
                    {{ opcao.label }}
                  </vivest-radio>
                }
              </div>
            </div>
          </div>
        </div>
        </div>
      </vivest-card>

      <!-- Parametrização de retenção: faixa de valor em reais (mínimo e máximo podem ser iguais) -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-retencao">
        <div class="resgate-bloco" formGroupName="retencao">
          <h2 id="resgate-bloco-retencao" class="resgate-bloco__titulo">Parametrização de retenção</h2>
          <p class="resgate-bloco__descricao">
            Opcional. Informe os valores em reais; quando preenchidos, devem ser maiores que zero e podem ser iguais.
          </p>

          <div class="resgate-retencao__campos">
            <div class="resgate-campo">
              <label class="campanha-form-label" for="resgate-retencao-min">
                Valor mínimo
              </label>
              <div class="resgate-moeda">
                <span class="resgate-moeda__prefixo" aria-hidden="true">R$</span>
                <input
                  id="resgate-retencao-min"
                  type="text"
                  inputmode="numeric"
                  appMascaraMoeda
                  placeholder="0,00"
                  class="form-control campanha-form-control resgate-moeda__input"
                  formControlName="valorMinimo"
                  [class.is-invalid]="
                    (retencao.controls.valorMinimo.touched && retencao.controls.valorMinimo.invalid) ||
                    retencao.hasError('retencaoIncoerente')
                  "
                  data-testid="resgate-retencao-min"
                />
              </div>
            </div>
            <div class="resgate-campo">
              <label class="campanha-form-label" for="resgate-retencao-max">
                Valor máximo
              </label>
              <div class="resgate-moeda">
                <span class="resgate-moeda__prefixo" aria-hidden="true">R$</span>
                <input
                  id="resgate-retencao-max"
                  type="text"
                  inputmode="numeric"
                  appMascaraMoeda
                  placeholder="0,00"
                  class="form-control campanha-form-control resgate-moeda__input"
                  formControlName="valorMaximo"
                  [class.is-invalid]="
                    (retencao.controls.valorMaximo.touched && retencao.controls.valorMaximo.invalid) ||
                    retencao.hasError('retencaoIncoerente')
                  "
                  data-testid="resgate-retencao-max"
                />
              </div>
            </div>
          </div>

          @if (retencaoValorInvalido) {
            <p class="resgate-erro" role="alert" data-testid="resgate-erro-retencao-valor">
              Os valores informados devem ser maiores que 0.
            </p>
          } @else if (retencao.hasError('retencaoIncoerente')) {
            <p class="resgate-erro" role="alert" data-testid="resgate-erro-retencao">
              O valor mínimo não pode ser maior que o máximo.
            </p>
          }
        </div>
      </vivest-card>

      <!-- Assinatura digital -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-assinatura">
        <div class="resgate-bloco" formGroupName="assinatura">
          <h2 id="resgate-bloco-assinatura" class="resgate-bloco__titulo">Assinatura digital</h2>

        <vivest-checkbox
          label-variant="multi-line"
          name="assinatura-obrigatoria"
          formControlName="obrigatoria"
          data-testid="resgate-assinatura-obrigatoria"
        >
          Exigir assinatura digital
        </vivest-checkbox>

        <!-- Rótulo, placeholder, lista, estado desabilitado e erro vêm do vivest-select. -->
        <vivest-select
          class="resgate-campo"
          label="Provedor"
          name="provedor"
          placeholder="Selecione o provedor"
          [options]="opcoesProvedor()"
          [status]="provedorComErro ? 'error' : 'default'"
          [attr.error-message]="provedorComErro ? 'Selecione o provedor da assinatura.' : ''"
          formControlName="provedor"
          data-testid="resgate-provedor"
        ></vivest-select>

        <div class="resgate-check-linha">
          <vivest-checkbox
            label-variant="multi-line"
            name="validacao-duas-etapas"
            formControlName="validacaoDuasEtapas"
            data-testid="resgate-duas-etapas"
          >
            Validação em duas etapas
          </vivest-checkbox>
          <app-tooltip-ajuda
            rotulo="Sobre a validação em duas etapas"
            texto="Exige uma segunda confirmação do participante ao assinar os documentos."
            data-testid="resgate-duas-etapas-ajuda"
          />
        </div>
        </div>
      </vivest-card>

      <!-- Documentos obrigatórios -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="resgate-bloco-documentos">
        <div class="resgate-bloco">
          <h2 id="resgate-bloco-documentos" class="resgate-bloco__titulo">Documentos obrigatórios</h2>
        <p class="resgate-bloco__descricao" id="resgate-documentos-descricao">
          Estes documentos serão pedidos ao participante na solicitação do resgate. Desmarque um
          documento para tirá-lo da lista.
        </p>

        @if (documentos.length) {
          <!-- Desmarcado continua visível até salvar, para poder ser marcado de volta. -->
          <ul
            class="resgate-documentos"
            formArrayName="documentos"
            aria-describedby="resgate-documentos-descricao"
          >
            @for (documento of documentos.controls; track documento.controls.id.value; let i = $index) {
              <li
                class="resgate-documentos__item"
                [class.resgate-documentos__item--desmarcado]="!documento.controls.marcado.value"
                [formGroupName]="i"
              >
                <vivest-checkbox
                  label-variant="multi-line"
                  name="documentos-obrigatorios"
                  [value]="documento.controls.nome.value"
                  formControlName="marcado"
                  [attr.data-testid]="'resgate-documento-' + i"
                >
                  {{ documento.controls.nome.value }}
                </vivest-checkbox>
              </li>
            }
          </ul>
        } @else {
          <p class="resgate-documentos__vazio" data-testid="resgate-documentos-vazio">
            Nenhum documento obrigatório. Use "Adicionar documento" para escolher os documentos
            pedidos ao participante.
          </p>
        }

        <vivest-button
          class="resgate-adicionar"
          variant="outline"
          size="sm"
          data-testid="resgate-adicionar-documento"
          (click)="abrirModalDocumentos()"
        >
          <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
          Adicionar documento
        </vivest-button>
        </div>
      </vivest-card>

      <footer class="resgate-rodape">
        @if (form.dirty) {
          <span class="resgate-rodape__aviso" data-testid="resgate-alteracoes-pendentes">
            Há alterações não salvas
          </span>
        }
        <div class="resgate-rodape__acoes">
          <!-- vivest-button renderiza um botão type="button": Salvar chama salvar() no clique. -->
          <vivest-button
            variant="outline"
            size="md"
            data-testid="resgate-cancelar"
            (click)="cancelar()"
          >
            Cancelar
          </vivest-button>
          <vivest-button
            variant="primary"
            size="md"
            [disabled]="salvando()"
            data-testid="resgate-salvar"
            (click)="salvar()"
          >
            {{ salvando() ? 'Salvando…' : 'Salvar' }}
          </vivest-button>
        </div>
      </footer>
    </form>
    }
  </div>

  <!--
    Confirmação antes de salvar (vivest-modal do design system). Fica sempre no DOM e abre por
    [open]; Esc (dismissible) e o fechamento nativo do <dialog> disparam vivest-close.
  -->
  <vivest-modal
    heading="Salvar configuração do resgate"
    [description]="descricaoConfirmacao()"
    [open]="confirmandoSalvar()"
    [hasIcon]="false"
    dismissible=""
    (vivest-close)="cancelarSalvar()"
    data-testid="resgate-confirmar-salvar"
  >
    <vivest-button
      slot="actions"
      variant="outline"
      size="md"
      data-testid="resgate-confirmar-voltar"
      (click)="cancelarSalvar()"
    >
      Voltar
    </vivest-button>
    <vivest-button
      slot="actions"
      variant="primary"
      size="md"
      data-testid="resgate-confirmar-salvar-btn"
      (click)="confirmarSalvar()"
    >
      Salvar
    </vivest-button>
  </vivest-modal>

  @if (modalDocumentosAberto()) {
    <app-resgate-documentos-modal
      [opcoes]="documentosDisponiveis()"
      [jaIncluidos]="idsDocumentos()"
      [carregando]="carregandoDocumentos()"
      (adicionar)="adicionarDocumentos($event)"
      (fechar)="fecharModalDocumentos()"
    />
  }
</section>
